exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".split-amount-row {\n  background: #fff;\n  padding: 3.5rem !important;\n  max-width: 60rem;\n  margin: 4rem auto;\n}\n\n.split-amount-row .form__item {\n  max-width: 49rem;\n  margin: 0 auto;\n}\n\n.split-amount-row .split-amount-row__title-field {\n  display: flex !important;\n  margin: 0 auto;\n  width: 49rem;\n}\n\n.split-amount-row .split-amount-row__title-field .input {\n  flex-grow: 1;\n  flex-shrink: 0;\n  max-width: 49rem;\n}\n\n.split-amount-row .split-amount-row__title-field .plus-button {\n  flex-shrink: 0;\n  margin-left: 2rem;\n}\n\n", ""]);

// exports
